export const NONE = 0;
export const INIT = 1;
export const SUCCESS = 2;
export const RESTRICTED = 3;
export const INTERNAL_ERROR = -100;


// WEBPACK FOOTER //
// ./js/constants/CreatePasswordStage.js